import React, { useMemo } from 'react';
import Grid from '../../Components/Formatting/Grid';
import { recipientStatuses, typeClasses } from '../../Data/Broadcasts';
import Icon from '../../Components/Icons/Icon';
import Button from '../../Components/Button/Button';
import { useDialogues } from '../../Components/Dialogues';
import Alert from '../../Components/Alert';

const Details = ({broadcast, send}) => {
    const stats = useMemo(() => {
        const stats = Object.entries(broadcast.stats).map(([key, value]) => {
            const type = recipientStatuses[key]?.type ?? 'unknown';
            return [
                <div className="flex items-center">
                    <Icon icon="Circle" theme="solid" size="lg" className={`${typeClasses[type].fg} mx-4`} />
                    {key}
                </div>,
                value,
                value > 0
            ];
        }).sort((a, b) => b[1] - a[1]);

        if (stats.filter(s => s[2]).length === 0) {
            return [[
                <div className="flex items-center">
                    <Icon icon="Circle" theme="solid" size="lg" className="fill-muted mx-4" />
                    <span className="text-muted">No customers added yet</span>
                </div>,
                null
            ]];
        }

        return stats;
    }, [broadcast.stats]);

    return <>

        <SendBroadcast {...{broadcast, send}} />

        <Grid items={[
            [
                <strong>Status</strong>,
                broadcast.status,
            ],
            [
                <strong>Purpose</strong>,
                broadcast.purpose,
            ],
            [
                <strong>Channels</strong>,
                broadcast.channels.join(', '),
            ],
            [
                <strong>Customer Statuses</strong>,
                null
            ],
            ...stats
        ]} />
    </>
}

const SendBroadcast = ({broadcast, send}) => {
    const {confirm} = useDialogues();

    switch(broadcast.status) {
        case 'Draft':
            return <Alert theme="secondary"
                title="Draft"
                icon="Pencil"
                message="This broadcast is a draft. Add customers and update your template to make it ready to send."
            />

        case 'Ready':
            return <Alert theme="primary"
                title="Ready to send"
                icon="PlayPause"
                message="Your broadcast is ready to send. If you're happy with your template and ready to go, click send."
                buttons={[
                    <Button key="send"
                        theme="primary"
                        label="Send"
                        onClick={() => confirm(
                            {
                                theme: 'primary',
                                title: 'Send broadcast',
                                icon: 'PaperPlane',
                                message: <>
                                    Are you sure you want to send this broadcast? Your message will be send to all available customers.
                                    <br />
                                    <br />
                                    Once you click send you won't be able to stop the broadcast or recall the messages.
                                </>,
                                confirmLabel: 'Send',
                            },
                            () => send()
                        )}
                    />
                ]}
            />

        case 'Scheduled':
            return <Alert theme="info"
                icon="Click"
                title="Scheduled"
                message="This broadcast is scheduled. We've not implemented this yet, so should shouldn't be seeing this..."
            />

        case 'Sending':
            return <Alert theme="primary"
                icon="PaperPlane"
                title="Sending"
                message="This broadcast being sent to customers."
            />

        case 'Sent':
            return <Alert theme="success"
                icon="Check"
                title="Sent"
                message="This broadcast has been sent."
            />

        case 'Archived':
            return <Alert theme="secondary"
                icon="FolderOpen"
                title="Archived"
                message="This broadcast has been archived."
            />

        default:
            return <Alert theme="error"
                title="Unknown status"
                message={`This broadcast has an unknown status (${broadcast.status}). Please contact support.`}
            />

    }

}

export default Details;